module.exports = __webpack_public_path__ + "static/media/PM8.d493f443.png";